const config = {
    apiUrl: "https://www.limbach-fuer-alle.de/api",
  };
  
  export default config;